/**
 * Helpers to read the active legal-document versions (Terms of Service /
 * Privacy Policy) from the meta tags injected by the server (#555).
 *
 * Used by the re-acceptance page (`routes/accept_terms/accept_terms.tsx`)
 * so it can display the exact version strings the user is about to accept.
 */

export function getTocVersion(): string {
    const meta = document.head.querySelector('meta[name=bf-toc-version]') as HTMLMetaElement | null;
    return meta?.content ?? '';
}

export function getPrivacyVersion(): string {
    const meta = document.head.querySelector('meta[name=bf-privacy-version]') as HTMLMetaElement | null;
    return meta?.content ?? '';
}
